/* GreenFox Theme - Global Utilities */

const GreenFox = {
  /**
   * Returns current store mode from body data attribute.
   * @returns {'retail'|'wholesale'}
   */
  getStoreMode() {
    return document.body.dataset.storeMode || 'retail';
  },

  /**
   * Check if current store is in wholesale mode.
   * @returns {boolean}
   */
  isWholesale() {
    return this.getStoreMode() === 'wholesale';
  },
};

window.GreenFox = GreenFox;
